import { render, staticRenderFns } from "./UserManagementTable.vue?vue&type=template&id=f0a12ff6&scoped=true&"
import script from "./UserManagementTable.vue?vue&type=script&lang=js&"
export * from "./UserManagementTable.vue?vue&type=script&lang=js&"
import style0 from "./UserManagementTable.vue?vue&type=style&index=0&id=f0a12ff6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a12ff6",
  null
  
)

export default component.exports